import * as React from 'react';

import { PageConfig_PageName as PageName } from '__generated__/graphql-types';

import PageContext from 'bundles/page-config-common/contexts/PageContext';
import ComponentsConfigProvider from 'bundles/page-config-common/providers/ComponentsConfigProvider';
import HeaderLevelOrderProvider from 'bundles/page-config-common/providers/HeaderLevelOrderProvider';
import AcademicDisciplineProvider from 'bundles/page-config-common/providers/enterprise/AcademicDisciplineProvider';
import EmbeddedPromoTemplatePageProvider from 'bundles/page-config-common/providers/enterprise/EmbeddedPromoTemplatePageProvider';
import EnterpriseAssignedCoursesCollectionProvider from 'bundles/page-config-common/providers/enterprise/EnterpriseAssignedCoursesCollectionProvider';
import EnterpriseBadgeCollectionsProvider from 'bundles/page-config-common/providers/enterprise/EnterpriseBadgeCollectionsProvider';
import EnterpriseBrowseCollectionsProvider from 'bundles/page-config-common/providers/enterprise/EnterpriseBrowseCollectionsProvider';
import EnterpriseCollectionsProvider from 'bundles/page-config-common/providers/enterprise/EnterpriseCollectionsProvider';
import EnterpriseCuratedCollectionsProvider from 'bundles/page-config-common/providers/enterprise/EnterpriseCuratedCollectionsProvider';
import EnterpriseCurriculumClipsProvider from 'bundles/page-config-common/providers/enterprise/EnterpriseCurriculumClipsProvider';
import EnterpriseDomainPillsProvider from 'bundles/page-config-common/providers/enterprise/EnterpriseDomainPillsProvider';
import EnterpriseEnrolledCourseProvider from 'bundles/page-config-common/providers/enterprise/EnterpriseEnrolledCourseProvider';
import EnterpriseForCreditCollectionProvider from 'bundles/page-config-common/providers/enterprise/EnterpriseForCreditCollectionProvider';
import EnterpriseOnboardingProvider from 'bundles/page-config-common/providers/enterprise/EnterpriseOnboardingProvider';
import EnterpriseSkillsClipsProvider from 'bundles/page-config-common/providers/enterprise/EnterpriseSkillsClipsProvider';
import EnterpriseSkillsProvider from 'bundles/page-config-common/providers/enterprise/EnterpriseSkillsProvider';
import EnterpriseSpecializationSessionsProvider from 'bundles/page-config-common/providers/enterprise/EnterpriseSpecializationSessionsProvider';
import EnterprisePageDataProvider from 'bundles/unified-common/providers/EnterprisePageDataProvider';
import MiniModalRedirectProvider from 'bundles/unified-home-common/providers/enterprise/MiniModalRedirectDataProvider';

const EnterpriseHomePageProvider = ({ children }: React.PropsWithChildren<{}>) => {
  return (
    <PageContext.Provider value={{ isEnterprise: true }}>
      <ComponentsConfigProvider pageName={PageName.EnterpriseHome}>
        <MiniModalRedirectProvider>
          <EnterprisePageDataProvider>
            <HeaderLevelOrderProvider>
              <EnterpriseOnboardingProvider>
                <EnterpriseSkillsProvider skillLimit={6}>
                  <EnterpriseSkillsClipsProvider>
                    <EnterpriseBrowseCollectionsProvider>
                      <EnterpriseForCreditCollectionProvider>
                        <EnterpriseCuratedCollectionsProvider>
                          <EnterpriseSpecializationSessionsProvider>
                            <EnterpriseCurriculumClipsProvider>
                              <EnterpriseAssignedCoursesCollectionProvider>
                                <EnterpriseBadgeCollectionsProvider>
                                  <EnterpriseCollectionsProvider>
                                    <AcademicDisciplineProvider>
                                      <EnterpriseEnrolledCourseProvider>
                                        <EnterpriseDomainPillsProvider>
                                          <EmbeddedPromoTemplatePageProvider>
                                            {children}
                                          </EmbeddedPromoTemplatePageProvider>
                                        </EnterpriseDomainPillsProvider>
                                      </EnterpriseEnrolledCourseProvider>
                                    </AcademicDisciplineProvider>
                                  </EnterpriseCollectionsProvider>
                                </EnterpriseBadgeCollectionsProvider>
                              </EnterpriseAssignedCoursesCollectionProvider>
                            </EnterpriseCurriculumClipsProvider>
                          </EnterpriseSpecializationSessionsProvider>
                        </EnterpriseCuratedCollectionsProvider>
                      </EnterpriseForCreditCollectionProvider>
                    </EnterpriseBrowseCollectionsProvider>
                  </EnterpriseSkillsClipsProvider>
                </EnterpriseSkillsProvider>
              </EnterpriseOnboardingProvider>
            </HeaderLevelOrderProvider>
          </EnterprisePageDataProvider>
        </MiniModalRedirectProvider>
      </ComponentsConfigProvider>
    </PageContext.Provider>
  );
};

export default EnterpriseHomePageProvider;
